export default function ClientFilters() {
  return (
    <div className="bg-white rounded-lg p-4 shadow-[0_4px_16px_rgba(10,42,67,0.08)]">
      <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">Buscar Cliente</label>
          <div className="relative">
            <i className="ri-search-line absolute left-3 top-1/2 -translate-y-1/2 text-gray-400"></i>
            <input
              type="text"
              placeholder="Nombre, RFC, ID..."
              className="w-full pl-10 pr-4 py-2 text-sm border border-gray-200 rounded-md focus:outline-none focus:ring-2 focus:ring-[#2F80ED] focus:border-transparent"
            />
          </div>
        </div>
        
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">Estado</label>
          <select className="w-full px-4 py-2 text-sm border border-gray-200 rounded-md focus:outline-none focus:ring-2 focus:ring-[#2F80ED] focus:border-transparent">
            <option>Todos</option>
            <option>Activo</option>
            <option>Inactivo</option>
            <option>Prospecto</option>
          </select>
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">Tipo</label>
          <select className="w-full px-4 py-2 text-sm border border-gray-200 rounded-md focus:outline-none focus:ring-2 focus:ring-[#2F80ED] focus:border-transparent">
            <option>Todos</option>
            <option>Importador</option>
            <option>Exportador</option>
            <option>Ambos</option>
          </select>
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">Ejecutivo</label>
          <select className="w-full px-4 py-2 text-sm border border-gray-200 rounded-md focus:outline-none focus:ring-2 focus:ring-[#2F80ED] focus:border-transparent">
            <option>Todos</option>
            <option>María González</option>
            <option>Carlos Ruiz</option>
            <option>Ana Martínez</option>
          </select>
        </div>
      </div>
    </div>
  );
}
